import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { Config, ImmutableTree, Utils as QbUtils } from '@react-awesome-query-builder/mui';

type QueryBuilderStringsProps = {
  internalTree: ImmutableTree;
  config: Config;
};

export default function QueryBuilderDebugInfo({ internalTree, config }: QueryBuilderStringsProps) {
  return (
    <Box>
      <Typography variant="h4">QueryBuilderStrings</Typography>

      <Accordion>
        <AccordionSummary>
          <Typography component="span">Query builder Json Tree</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: '10px' }}>
          <pre>{JSON.stringify(QbUtils.getTree(internalTree), null, 4)}</pre>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary>
          <Typography component="span">Config</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: '10px' }}>
          <pre>{JSON.stringify(config, null, 4)}</pre>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
